import React from "react";
import UsergroupIcon from "../../../assets/icons/user_group.svg2";
import { useGetActiveUsersWidgetDataQuery } from "../../store/slices/widgetsSlice";
import HelpButton from "../../HelpContent/HelpButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGripVertical, faRotate } from "@fortawesome/free-solid-svg-icons";
import { AbsoluteLoadingIndicator } from "../FullScreenLoadingIndicator";

export default function ActiveUsersWidget() {
  // const [data, setdata] = useState({ registeredUsers: 12.455, difference: 28 ,thisWeek:1});
  const {
    data = { today: 0, yesterday: 0, previousWeek: 0, thisWeek: 0 },
    isLoading,
    isFetching,
    refetch,
  } = useGetActiveUsersWidgetDataQuery();
  const loading = isLoading || isFetching;
  const difference = data.today - data.yesterday;

  return (
    <div className="h-100 text-white rounded-3 px-2 position-relative d-flex flex-column">
      <AbsoluteLoadingIndicator loading={loading} />
      <div className="p-3 pb-1">
        <UsergroupIcon width={20} className="me-2 white opacity-50" />
        <span className="small fw-bold">ACTIVE USERS </span>
        <button
          className="btn p-0 text-white ms-2"
          onClick={() => refetch()}
          disabled={loading}
          title="Refresh active users data"
        >
          <FontAwesomeIcon
            icon={faRotate}
            className={`opacity-50 ${loading ? "spin" : ""}`}
          />
        </button>
        <HelpButton helpKey="widget-active-users" iconClassName="white" />{" "}
        <FontAwesomeIcon
          icon={faGripVertical}
          className="ms-4 opacity-50 widget-header"
        />
      </div>
      <hr className="text-white m-1" />
      <div className="flex-grow-1 d-flex flex-column justify-content-center h-100 align-items-center">
        <div className="text-center my-3">
          <h1 className="fw-bold display-4 m-0">{data.today}</h1>
          <h6 className="opacity-75 fw-bold">TOTAL ACTIVE TODAY</h6>
          {difference > 0 && (
            <div className="text-green fw-bold">
              <span className="fs-4 align-top">&#9650; &#43;</span>
              <span className="fs-3">{difference}</span>
              <div className="fs-6 fw-bold text-white">vs previous day</div>
            </div>
          )}
          {difference < 0 && (
            <div className="text-red fw-bold">
              <span className="fs-4 align-top">&#9660; &minus;</span>
              <span className="fs-3">{Math.abs(difference)}</span>
              <div className="fs-6 fw-bold text-white">vs previous day</div>
            </div>
          )}
          {difference === 0 && (
            <div className="text-red fw-bold">
              <span className="fs-3">no change</span>
              <div className="fs-6 fw-bold text-white">vs previous day</div>
            </div>
          )}
        </div>
        <div className=" text-white opacity-75 fw-bold text-center my-2">
          <div>{data.thisWeek}</div>
          <div>this week</div>
        </div>
        <div className=" text-white opacity-75 text-center my-2">
          <div>{data.previousWeek}</div>
          <div>previous week</div>
        </div>
      </div>
    </div>
  );
}
